<script>
  import { format } from 'svelte-i18n';
  import { Button, Modal, ModalBody, ModalFooter } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { deepCopy } from '@common/utils/objects';

  import { AccountFormContent } from '../shared';

  export let data = {};
  export let onUpdate = () => {};
  export let show = false;
  export let isDomains = false;
  export let targeting = {};
  export let campaigns = [];
  export let tags = [];

  let originalConfig = deepCopy(data);
  let valid = true;

  const onCancelHandler = () => {
    data = originalConfig;
    show = false;
  };

  const onUpdateHandler = () => {
    if (data.name !== originalConfig.name && originalConfig?.name.length) {
      data.new = true;
      onUpdate(data, originalConfig);
    } else {
      onUpdate(data);
    }

    show = false;
  };

  const onKeyUpHandler = (e) => {
    const exists = targeting.accounts.some((account) => account.name === e.target.value);
    valid = !exists;
  };

  $: disabled = !data?.name.length;
</script>

<Modal bind:isOpen={show} size="md" fullscreen="sm">
  <ModalBody class="targeting-accounts-modal">
    <button class="close" on:click={() => (show = !show)}>
      <Icon name="x" />
    </button>

    <div class="heading">
      {#if data.new}
        {#if isDomains}
          <h1>{$format('label.ADD_DOMAIN')}</h1>
        {:else}
          <h1>{$format('label.ADD_RECIPIENT')}</h1>
        {/if}
      {:else if isDomains}
        <h1>{$format('label.EDIT')} {data.name}</h1>
      {:else}
        <h1>{$format('label.EDIT')} {data.name}</h1>
      {/if}
    </div>

    <AccountFormContent bind:data {isDomains} bind:valid {campaigns} {tags} {onKeyUpHandler} />
  </ModalBody>
  <ModalFooter class="border-top p-4 mt-4">
    <Button color="link" on:click={onCancelHandler}>
      {$format('label.CANCEL')}
    </Button>
    <Button color="primary" on:click={onUpdateHandler} disabled={!(valid && !disabled)}>
      {$format('label.UPDATE')}
    </Button>
  </ModalFooter>
</Modal>

<style lang="scss" src="./edit.scss"></style>
